import React, { Component, Fragment } from 'react'
import { Breadcrumb, Card, Layout, Row } from 'antd'

import style from '../../../components/Main/Standards/style.css'
import { withRouter } from 'react-router-dom'
import StandardModal from '../../../components/Main/Standards/StandardModal'
import List from '../../../components/Main/Standards/List'

const { Content } = Layout

class Standards extends Component {
  render () {
    return (
      <Fragment>
        <StandardModal key={'standard-modal'} {...this.props} />
        <Content style={{ margin: '0px 0px' }}>
          <Card>
            <Row className={style.pageHeader}>
              <Breadcrumb>
                <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
                <Breadcrumb.Item>Library</Breadcrumb.Item>
                <Breadcrumb.Item>Standard</Breadcrumb.Item>
              </Breadcrumb>
              <h2 className={style.title}>Standard </h2>
              <p className={style.paragraph}>List of all Standard.</p>
            </Row>
          </Card>
          <Card>
            <List {...this.props} />
          </Card>
        </Content>
      </Fragment>
    )
  }
}

export default withRouter(Standards)
